//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      rowStyleOption: {
        stripe: true,
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          return "table-body-cell-class";
        },
      },
      columns: [
        {
          field: "name",
          key: "a",
          title: "名称",
          align: "left",
          width: 200,
          fixed: "left",
        },
        {
          field: "qichuyue",
          key: "b",
          title: "期初余额",
          width: 120,
          align: "right",
        },
        {
          field: "jiefang",
          key: "c",
          title: "借方",
          width: 120,
          align: "right",
        },
        {
          field: "daifang",
          key: "d",
          title: "贷方",
          width: 120,
          align: "right",
        },
        {
          field: "yue",
          key: "e",
          title: "余额",
          width: 120,
          align: "right",
        },
      ],
      tableData: [
        {
          name: "04 - 星光美",
          qichuyue: "-1,000,000.00",
          yue: "-1,000,000.00",
        },
        {
          name: "102 - 钟爱一生",
          qichuyue: "-1,000,000.00",
          yue: "-1,000,000.00",
        },
        {
          name: "121 - 朗月珠宝",
          qichuyue: "-671,000.00",
          yue: "-671,000.00",
        },
        {
          name: "20 - 重庆中晖",
          qichuyue: "-1,000,000.00",
          yue: "-1,000,000.00",
        },
        {
          name: "37 - 周大生珠宝股份有限公司",
          daifang: "1,000,000.00",
          yue: "-1,000,000.00",
        },
        {
          name: "合计",
          qichuyue: "-3,671,000.00",
          daifang: "1,000,000.00",
          yue: "-4,671,000.00",
        },
      ],
    };
  },
};
